import { render, staticRenderFns } from "./MyBasicsEdit.vue?vue&type=template&id=f9991820&"
import script from "./MyBasicsEdit.vue?vue&type=script&lang=js&"
export * from "./MyBasicsEdit.vue?vue&type=script&lang=js&"
import style0 from "./MyBasicsEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports